import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: `${THEME.spacing.sm}px 0`,
		fontSize: THEME.typography.fontSizes.sm,
	},
	row: {
		display: 'flex',
		alignItems: 'flex-end',
		gap: THEME.spacing.md,
		flexWrap: 'wrap' as const,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		flex: 1,
		minWidth: 160,
	},
	fieldLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	// Compact width for the numeric scale-bound selects.
	scaleSelectField: {
		flex: 'none',
		minWidth: 120,
	},
});
